// src/components/LeaderNeedsSection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaLaptopCode, FaProjectDiagram, FaHandshake } from "react-icons/fa";
import "./LeaderNeedsSection.css";

const LeaderNeedsSection = () => {
  const steps = [
    {
      id: 1,
      icon: <FaLaptopCode />,
      title: "Software",
      desc: "That actually gets adopted",
    },
    {
      id: 2,
      icon: <FaProjectDiagram />,
      title: "Projects",
      desc: "Delivered on time and within budget",
    },
    {
      id: 3,
      icon: <FaHandshake />,
      title: "One Partner",
      desc: "That unifies business, technical, and trade transformation",
    },
  ];

  return (
    <section className="leader-needs-section py-5">
      <Container>
        {/* Heading */}
        <Row className="justify-content-center text-center mb-4">
          <Col md={10}>
            <p className="section-subtitle">FOR LEADERS WHO NEED</p>
            <h2 className="section-title">We Help You Achieve Success</h2>
          </Col>
        </Row>

        {/* Steps */}
        <div className="steps-wrapper position-relative">
          {/* Curved line */}
          <svg
            className="steps-line"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 200"
            preserveAspectRatio="none"
          >
            <path
              d="M 50 150 Q 500 -50 950 150"
              stroke="#ddd"
              strokeWidth="2"
              fill="transparent"
              strokeDasharray="5,5"
            />
          </svg>

          <Row className="text-center">
            {steps.map((step) => (
              <Col md={4} sm={12} key={step.id} className="mb-4">
                <div className="step-box">
                  <div className="step-icon">
                    <span className="step-number">{step.id}</span>
                    {step.icon}
                  </div>
                  <h5>{step.title}</h5>
                  <p>{step.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default LeaderNeedsSection;
